/**
 * ChatMessageAttachment 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { ChatMessageAttachmentExtraData } from './chat_message_attachment_extra_data'

/**
 * ChatMessageAttachment
 */
export interface ChatMessageAttachment {
  /** 附件类型 */
  type?: string
  /** 作者名称 */
  author_name?: string
  /** 标题 */
  title?: string
  /** 标题链接 */
  title_link?: string
  /** 文本内容 */
  text?: string
  /** 图片URL */
  image_url?: string
  /** 缩略图URL */
  thumb_url?: string
  /** 资源URL */
  asset_url?: string
  /** OG抓取URL */
  og_scrape_url?: string
  /** 额外数据 */
  extra_data?: ChatMessageAttachmentExtraData
}

/**
 * ChatMessageAttachment Schema
 */
export const ChatMessageAttachmentSchema: SchemaDefinition = {
  properties: {
    type: {
      description: '附件类型',
      format: 'cons.ChatMessageAttachmentType',
      type: 'string',
      label: '附件类型',
    },
    author_name: {
      description: '作者名称',
      format: 'string',
      type: 'string',
      label: '作者名称',
    },
    title: {
      description: '标题',
      format: 'string',
      type: 'string',
      label: '标题',
    },
    title_link: {
      description: '标题链接',
      format: 'string',
      type: 'string',
      label: '标题链接',
    },
    text: {
      description: '文本内容',
      format: 'string',
      type: 'string',
      label: '文本内容',
    },
    image_url: {
      description: '图片URL',
      format: 'string',
      type: 'string',
      label: '图片URL',
    },
    thumb_url: {
      description: '缩略图URL',
      format: 'string',
      type: 'string',
      label: '缩略图URL',
    },
    asset_url: {
      description: '资源URL',
      format: 'string',
      type: 'string',
      label: '资源URL',
    },
    og_scrape_url: {
      description: 'OG抓取URL',
      format: 'string',
      type: 'string',
      label: 'OG抓取URL',
    },
    extra_data: {
      $ref: 'ChatMessageAttachmentExtraData',
      description: '额外数据',
      label: '额外数据',
    },
  },
  type: 'object',
}
